export default __webpack_public_path__ + "static/media/ios-plus.641ec6ad.svg";